var SelectionStyle;
(function (SelectionStyle) {
    SelectionStyle["NONE"] = "none";
    SelectionStyle["RADIO"] = "radio";
})(SelectionStyle || (SelectionStyle = {}));
export { SelectionStyle, };
//# sourceMappingURL=selection-style.js.map